import EnrollManage from './src/main';

/* istanbul ignore next */
EnrollManage.install = function(Vue) {
  Vue.component(EnrollManage.name, EnrollManage);
};

export default EnrollManage;
